module.exports = __webpack_public_path__ + "media/images/illustrations/browser-support-6537ba5b1dd89e7d3c9374e8c3f37e0b.png";